import React from 'react';
import classNames from 'classnames';

import './index.scss';
import Loading from '$/components/loading/Loading';

interface IBixButtonProps {
  light?: boolean;
  type?: 'submit' | 'reset' | 'button';
  disabled?: boolean;
  useLoading?: boolean;
  isLoading?: boolean;
  onClick?: (...args: any) => void;
  useSmall?: boolean;
  children: React.ReactNode;
  className?: string;
}

const BixButton: React.FC<IBixButtonProps> = props => {
  const { type, light, disabled, onClick, useLoading, isLoading, useSmall, className } = props;
  return (
    <button
      onClick={onClick}
      type={type || 'button'}
      disabled={disabled}
      className={classNames('bix_button', className, { light, use_loading: useLoading, use_small: useSmall })}>
      {props.children}
      {isLoading && <Loading inline color={light ? 'primary' : 'secondary'} />}
    </button>
  );
};

export default BixButton;
